import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ModuleState, PageState} from './aufgaben-berechtigungen-home.reducer';
import {ListInputItem} from '../../../shared/sopi-list/sopi-list.model';


export const getModuleState = createFeatureSelector<ModuleState>('AufgabenBerechtigungenPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

export const getFunktionsbereiche = createSelector(getPageState, (state: PageState) => {
    const res: Array<ListInputItem> = [];
    state.funktionsbereiche.forEach((fb) => {
        res.push(<ListInputItem>{
            groupId: '',
            groupTitle: '',
            group: null,
            itemId: fb.funktionsbereich_id,
            itemTitle: fb.titel,
            item: fb
        });
    });
    return res;
});

export const getFunktionsbereicheLaden = createSelector(getPageState, (state: PageState) => state.funktionsbereicheLaden);
export const getFunktionsbereicheFehler = createSelector(getPageState, (state: PageState) => state.funktionsbereicheFehler);


